import * as React from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import DefaultUserPage from './DefaultUserPage';

interface RouteParams { 
  url: string 
};

function DefaultUser({ match }: RouteComponentProps<RouteParams>) {
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={DefaultUserPage}
      />
    </Switch>
  );
}

export default DefaultUser;
